<template>
  <a-card :bordered="false">
    <div class='mb25 s_flex_ali' v-if="total<5">
      <span class='mr15'>
        <a-button type="primary" @click=" createBrands">
          <PlusOutlined />
          添加品牌
        </a-button>
      </span>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='list'>
      <template v-slot:dealer="{ record }">
        <a href="javascript:;" @click="showDealer(record)">{{record.dealer}}</a>
      </template>
      <template v-slot:store="{ record }">
        <a href="javascript:;"  @click="showStore(record)">{{record.store}}</a>
      </template>
      <template v-slot:action="{ record }">
        <a v-has:updateBrand="()=>editBrand(record)" href="javascript:;" class="m-r-10">修改</a>
        <a v-has:delBrand="()=>delBrand(record)" href="javascript:;">删除</a>
      </template>
    </a-table>
     <!-- <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  /> -->
  </a-card>
   <a-modal :keyboard="false" v-model:visible="dealerVisible" centered  :width='1200'  destroyOnClose>
     <dealerList :currentData="brandData" />
   </a-modal>
   <a-modal :keyboard="false" v-model:visible="storeVisible" centered  :width='1200'  destroyOnClose>
     <storeList :currentData="brandData"/>
   </a-modal>
   <a-modal :keyboard="false" v-model:visible="createVisible" :title="createData.id?'修改品牌':'添加品牌'" centered  @ok="confirmBrand"   destroyOnClose>
        <a-form>
          <a-form-item label="品牌名称" help="品牌名称限制16字内"><a-input :maxLength="16" v-model:value="createData.sub_brand_name" style="width:200px"></a-input></a-form-item>
        </a-form>
   </a-modal>
</template>

<script>
import useTableSearch from "@/hooks/useTableSearch";
import { onMounted, reactive, ref, toRefs } from "@vue/runtime-core";
import dealerList from './components/dealerList'
import storeList from './components/storeList'
import {subBrand,subBrandDel,brandCreate,brandUpdate} from '@/api/brand'
import { message, Modal } from 'ant-design-vue';
import { iscode } from '../../utils/app';
const defSearch = {limit:10, page:1};
const columns = [
  {
    title: "品牌名称",
    dataIndex: "sub_brand_name",
  },
  {
    title: "关联门店",
    dataIndex: "store",
    slots: { customRender: "store" },
  },
  {
    title: "关联经销商",
    dataIndex: "dealer",
    slots: { customRender: "dealer" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components:{storeList,dealerList},
  setup() {
    const state=reactive({
      dealerVisible:false,
      storeVisible:false,
      storeData:{},
      dealerData:{},
      createVisible:false,
      brandData:{}
    })
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      allNum,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      allNum,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(subBrand, search.value);
    });
    const createVisible=ref(false)
    const createData=ref({})
    // 添加品牌
    const createBrands = () => {
      createVisible.value=true
      createData.value={
        sub_brand_name:''
      }
    };
    const confirmBrand=async ()=>{
        if(!createData.value.sub_brand_name){
          return message.error("请输入品牌名称")
        }
        let result;
        if(createData.value.id){
         result=await brandUpdate(createData.value).then(res=>res.data).catch(error=>error)
        }else{
         result=await brandCreate(createData.value).then(res=>res.data).catch(error=>error)
        }
        if(iscode(result,true)){
          createVisible.value=false
          tableHoosks.pageSearchChange()
        }
    }
    // 修改
    const editBrand=(data)=>{
      createData.value=JSON.parse(JSON.stringify(data))
      createVisible.value=true
    }
    // 关联经销商
    const showDealer=(data)=>{
      state.dealerVisible=true
      state.brandData=data
    }
    // 关联门店、
    const showStore=(data)=>{
        state.storeVisible=true
        state.brandData=data
    }
    // 删除品牌
    const delBrand=(data)=>{
            Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await subBrandDel(data.id ).then((res) => res.data);
          if (iscode(res, true)) {
            tableHoosks.pageSearchChange()
          }
        },
      });
    }
    return {
      ...tableHoosks,
      columns,
      createBrands,
      ...toRefs(state),
      showDealer,
      showStore,
      createVisible,
      createData,
      confirmBrand,
      delBrand,
      editBrand
    };
  },
};
</script>